import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router';
import { Divider, Empty, Table, Button, Col, Select, Drawer, Form, Input, Row, Switch, Space, message, Modal, Typography, DatePicker } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import PageApp from '../../../Page';
import {getAllByAcomulado, drop as dropConcept} from '../../../../apis/ConceptoAcomuladoApi';
import {insert, getById } from '../../../../apis/AcomuladoApi';
import {getList as getAllConcepts} from '../../../../apis/ConceptoApi';
import Conceptos from './Conceptos'
import _ from 'lodash';
import {
    HomeOutlined,
    UnorderedListOutlined,
  } from '@ant-design/icons';

const { Title } = Typography;
const { TextArea } = Input;
const { Option } = Select;
const { confirm } = Modal;

const ConceptoAcomuladoAddPage = () => {
    let navigate = useNavigate();
    const [ form ] = Form.useForm()
    const { id } = useParams();
    const [ID, setID] = useState(id == -1? null: id);
    const [modified, setModified] = useState(false);
    const [initialValues, setInitialValues] = useState(null);
    const [concepts, setConcepts] = useState([]);
    const [openNewAcomulado, setOpenNewAcomulado] = useState(false);
    const [dataAcomulados, setDataAcomulados] = useState([]);
    const [selectedDetail, setSelectedDetail] = useState(null);
    const searchInput = useRef(null);
    
    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            if(!values) return;
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
            return;
        }

        const fields = form.getFieldsValue()
        //Create
        const payload = {
            id: ID,
            ...fields
        }
        const response = await insert(payload);
        if(response.ok){
            setID(response.payload);
            message.success('Se guardo correctamente el registro!');
        }

        setModified(true);
    }

    const effectRan = useRef(false);
    useEffect(() => {
        if (!effectRan.current) {
            (async () => {
                await getConcepts();
                if(ID > 0){
                    await refreshConceptosByAcomulado();
                    await refreshData();
                }else{
                    setInitialValues({
                        concepto_id: null,
                        activo: true
                    });
                }
                setModified(false)
            })();
        }
        return () => effectRan.current = true;
    }, []);

    const onClose = ()=>{
        return navigate("../concepto_acomulado");
    }

    const getConcepts = async ()=>{
        const response = await getAllConcepts();
        if(response.ok){
          let conceptsList = response.payload;
          setConcepts(conceptsList);
        }
    }

    const refreshData = async ()=> {
        const response = await getById(ID);
        if(response.ok){
            let concept = response.payload;
            setInitialValues(concept);
        }
    }

    //Me trae la lista de conceptos del acumulado
    const refreshConceptosByAcomulado = async ()=> {
        const response = await getAllByAcomulado(ID);
        if(response.ok){
            let list = response.payload;
            setDataAcomulados(list);
        }
    }

    const onClickNewDetail = ()=>{
        setOpenNewAcomulado(true);
        setSelectedDetail(null);
    }

    const finishDetail = async () => {
        setOpenNewAcomulado(false);
        await refreshConceptosByAcomulado();
    }

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas en eliminar el concepto?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar su información',
            onOk: ()=>{deleteOk(item.id)},
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOk = async (id)=>{
        const response = await dropConcept(id);
        if(response.ok){
            message.success('¡El concepto ha sido eliminadó!');
            await refreshConceptosByAcomulado();
        }
    }

    const goToDetails = (object)=>{
        return navigate("../concepto_acomulados/" + object.concepto_id);
    }

    const columns = [
        {
            title: 'Clave',
            dataIndex: 'concepto.clave',
            key: 'concepto.clave',
            render: (item, object)=> {
                return <Space>
                <span>{object.concepto?.clave}</span>
                </Space>
            }
        },
        {
            title: 'Descripcion',
            dataIndex: 'concepto.descripcion',
            key: 'concepto.descripcion',
            render: (item, object)=> {
                return <Space>
                <span>{object.concepto?.descripcion}</span>
                </Space>
            }
        },
        {
            title: '',
            dataIndex: 'actions',
            key: 'actions',
            render: (item, object)=> {
                return <Space>
                    <Button type='primary' size='small' onClick={()=>{
                        goToDetails(object);
                    }}>Ver</Button>
                    <Button type='primary' size='small' onClick={()=>{
                        setOpenNewAcomulado(true);
                        setSelectedDetail(object);
                    }}>Editar</Button>
                    <Button type='primary' size='small' danger onClick={()=>{
                        deleteConfirm(object);
                    }}>Eliminar</Button>
                </Space>
            }
        }
    ];
        
    const routes = [  
        {
            href: '',
            title: <>
            <HomeOutlined />
            <span>Inicio</span>
            </>,
        },
        {
            href: '',
            title: (
            <>
                <UnorderedListOutlined />
                <span>Catálogos</span>
            </>
            ),
        },
        {
            href: '../concepto_acomulado',
            title: (
            <>
                <UnorderedListOutlined />
                <span>Conceptos Acumulado</span>
            </>
            ),
        },
        {
            href: '',
            title: (
                <>
                <UnorderedListOutlined />
                <span>Acomulado</span>
                </>
            ),
        }
    ];

    return (
        <PageApp routes={routes}>
                <div style={{paddingBottom: 20}}>
                    <div style={{float: 'left'}}>
                        <span title=""></span>
                    </div>
                    <span class="" style={{float:'right'}}>
                    <Space>
                        <Button onClick={onClose}>Cancelar</Button>
                        {
                            ID > 0 ? null: 
                            <Button onClick={handleOk} type="primary">
                                Guardar
                            </Button>
                        }
                    </Space>
                    </span>
                </div>
                <Divider/>
                <div>
                    <div style={{float: 'left'}}>
                        <span title=""></span>
                    </div>
                    <span class="" style={{float:'right'}}>
                        
                    </span>
                </div>
                {/* <PageHeader ghost={false} title="Remisiones" extra={[ 
                <Space>
                    <Button onClick={onClose}>Cancelar</Button>
                    <Button onClick={handleOk} type="primary">
                    Guardar
                    </Button>
                </Space>]} />*/}
            {
                initialValues && 
                <Form 
                        layout="vertical" 
                        form={form} 
                        requiredMark 
                        autoComplete="off"
                        initialValues={initialValues} 
                        onFinish={handleOk}>
                        <Row gutter={16}>
                            {
                                concepts && concepts.length > 0 && 
                                <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                    <Form.Item
                                        name="concepto_id"
                                        label="Concepto"
                                        rules={[
                                        {
                                            required: true,
                                            message: 'Por favor selecciona el concepto',
                                        },
                                        ]}
                                    >
                                        <Select placeholder="Por favor selecciona el concepto" 
                                            showSearch
                                            filterOption={(input, option) =>
                                                (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                            }>
                                            {
                                                concepts.map((item)=><Option value={item.value}>{item.text}</Option>)
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>
                            }
                        </Row>
                </Form>
            }
            <Divider></Divider>
            <div style={{height: 60}}>
                <div style={{float: 'left'}}>
                    <Title level={2}>Conceptos</Title>
                </div>
                <span class="" style={{float:'right'}}>
                    <Space>
                        <Button disabled={!ID} onClick={onClickNewDetail} type="primary" style={{marginBottom: 10}}>Agregar concepto</Button>
                    </Space>
                </span>
            </div>
            {
                openNewAcomulado && 
                <div style={{marginBottom: 10}}>
                    {
                        !selectedDetail &&
                        <Conceptos title="Agregar concepto" conceptoId={ID} finish={finishDetail} open={openNewAcomulado}/>
                    }
                    {
                        selectedDetail &&
                        <Conceptos title="Editar concepto" conceptoId={ID} id={selectedDetail.id} finish={finishDetail} open={openNewAcomulado}/>
                    }
                </div>
            }
            {/* <Button disabled={!ID} onClick={onClickNewDetail} type="primary" style={{marginBottom: 10}}>Agregar nuevo detalle</Button> */}
            {
                dataAcomulados.length === 0 ? <Empty />:
                <Table dataSource={dataAcomulados} columns={columns} />
            }
        </PageApp>
    );
};
export default ConceptoAcomuladoAddPage;